import {
  HYPERSWITCH_APPEARANCE,
  HYPERSWITCH_PLACEHOLDER_KEYS,
} from '../common/constants/hyperswitchAppearance';

type AppearanceRule = Record<string, string>;

export function buildHyperswitchAppearance(
  translate: (key: string) => string,
): typeof HYPERSWITCH_APPEARANCE {
  const { variables } = HYPERSWITCH_APPEARANCE;
  const rules: Record<string, AppearanceRule> = { ...HYPERSWITCH_APPEARANCE.rules };

  for (const [field, key] of Object.entries(HYPERSWITCH_PLACEHOLDER_KEYS)) {
    rules[`.Input[name="${field}"]::placeholder`] = { color: 'transparent !important' };
    rules[`.relative:has(> .Input[name="${field}"]:placeholder-shown)::after`] = {
      content: JSON.stringify(translate(key)),
      position: 'absolute',
      top: '50%',
      left: '18px',
      transform: 'translateY(-50%)',
      color: variables.colorTextPlaceholder,
      fontFamily: variables.fontFamily,
      fontSize: variables.fontSizeBase,
      lineHeight: variables.fontLineHeight,
      pointerEvents: 'none',
    };
  }

  return { ...HYPERSWITCH_APPEARANCE, rules } as typeof HYPERSWITCH_APPEARANCE;
}
